import { render } from "./SupplementaryItems.vue?vue&type=template&id=4af15722"
import script from "./SupplementaryItems.vue?vue&type=script&lang=js"
export * from "./SupplementaryItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\git\\Giant-GIT\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__